"use client";

import Currency from "@client/components/formik/currency";
import Field from "@client/components/formik/field";
import Fieldset from "@client/components/lead-form/components/fieldset";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";
import { FormButton } from "@ui/js/components/buttons/form-button";

const INPUT_ID_AND_LABEL_HTMLFOR = "income-amount";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function IncomeAmount() {
	return (
		<>
			<Fieldset
				dialog="Understanding your annual income allows us to recommend financial solutions best suited to your economic standing. List your total available income including wages, retirement, investments, and rental properties. Alimony, child support or separate maintenance is optional and does not need to be included if you do not wish it to be considered as a basis for repaying a loan. Increase any non-taxable income or benefits by 25%."
				dialogHeader="What do we mean by annual income?"
				legend="What is your annual income?"
			>
				<Field
					{...setUserInteractionDataAttribute(
						`lead-form_step_${INPUT_ID_AND_LABEL_HTMLFOR}`,
					)}
					id={INPUT_ID_AND_LABEL_HTMLFOR}
					name={FIELD_NAME_SELECTOR}
					label="Income Amount"
				>
					<Currency
						id={INPUT_ID_AND_LABEL_HTMLFOR}
						name={FIELD_NAME_SELECTOR}
					/>
				</Field>
			</Fieldset>
			<FormButton
				{...setUserInteractionDataAttribute(
					`lead-form_submit-button_${INPUT_ID_AND_LABEL_HTMLFOR}`,
				)}
			/>
			<div className="form__consents">
				List your total available income including wages, retirement,
				investments, and rental properties. Alimony, child support or separate
				maintenance is optional and does not need to be included if you do not
				wish it to be considered as a basis for repayment. Increase any
				non-taxable income or benefits by 25%.
			</div>
		</>
	);
}
